import React from 'react'
import DepositReport from './DepositReport'
import RevenueBookingReport from './RevenueBookingReport'
import RevenueRecognitionReport from './RevenueRecognitionReport'
import InvoiceAgingReport from './InvoiceAgingReport'
import RoyaltyReport from './RoyaltyReport'
import SKUReport from './SKUReport'

function StaffReports() {
    return (
        <div>
            <div className='mt-6'>
                <DepositReport />
            </div>
            <div className='mt-6'>
                <SKUReport />
            </div>
            <div className='mt-6'>
                <RevenueBookingReport />
            </div>
            <div className='mt-6'>
                <RevenueRecognitionReport />
            </div>
            <div className='mt-6'>
                <InvoiceAgingReport view={"staff"} />
            </div>
            <div className='mt-6'>
                <RoyaltyReport />
            </div>
        </div>
    )
}

export default StaffReports